/*
egjs-list-differ
Copyright (c) 2019-present NAVER Corp.
MIT license
*/
export const SUPPORT_MAP = typeof Map === "function";
